import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogService } from 'ng2-bootstrap-modal';
import { IDatePickerConfig } from 'ng2-date-picker';
import { ToastrService } from 'ngx-toastr';
import { ConfigurationService } from 'src/app/shared/architecture/services/configuration.service';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { ConfirmComponent } from 'src/app/shared/modal/confirm/confirm.component';
import { Approval } from 'src/app/shared/models/approval.model';
import { Credit } from 'src/app/shared/models/credit.model';
import { CreditFilter } from 'src/app/shared/models/creditFilter.model';
import { BankService } from 'src/app/shared/services/core/bank.component.service';
import { CreditService } from 'src/app/shared/services/core/credit.service';
import { FrontOfficeRequestService } from 'src/app/shared/services/core/front-office-request.service';
import { FrontOfficesService } from 'src/app/shared/services/core/front-offices.service';

@Component({
  selector: 'app-lista-creditos',
  imports: [TegelModule, CommonModule],
  templateUrl: './lista-creditos.component.html',
  styleUrl: './lista-creditos.component.css'
})
export class ListaCreditosComponent implements OnInit {
  frontOffices!: any[];
  negs: any[] = [];
  banks: any[] = [];
  credits: Credit[] = [];
  creditFilter: CreditFilter;
  page = 1;
  total!: number;
  reverse: boolean = false;
  order = "ID";

  dateConfigPeriodFromForecast: IDatePickerConfig = {
   // locale: 'pt',
    format: 'DD/MM/YYYY',
    showMultipleYearsNavigation: true,
    disableKeypress: true
  };

  dateConfigUpToForecast: IDatePickerConfig = {
   // locale: 'pt',
    format: 'DD/MM/YYYY',
    showMultipleYearsNavigation: true,
    disableKeypress: true
  };

  dateConfigPeriodFrom: IDatePickerConfig = {
    //locale: 'pt',
    format: 'DD/MM/YYYY',
    showMultipleYearsNavigation: true,
    disableKeypress: true
  };

  dateConfigUpTo: IDatePickerConfig = {
   // locale: 'pt',
    format: 'DD/MM/YYYY',
    showMultipleYearsNavigation: true,
    disableKeypress: true
  };

  endDateConfig: IDatePickerConfig = {
   // locale: 'pt',
    format: 'DD/MM/YYYY',
    showMultipleYearsNavigation: true,
    disableKeypress: true
  };

  constructor(
    private dialogService: DialogService,
    private utilService: UtilService,
    private creditService: CreditService,
    private frontOfficesService: FrontOfficesService,
    private bankService: BankService,
    private toastr: ToastrService,
    private frontOfficeRequestService: FrontOfficeRequestService,
    private configurationService: ConfigurationService,
    private util: UtilService
  ) {
    this.creditFilter = new CreditFilter();
    this.credits = [];

    this.frontOfficesService.get().subscribe((result) => {
      this.frontOffices = result;
    });
    this.bankService.getPartnerBanks().subscribe((result) => {
      this.banks = result;
    })
    this.frontOfficeRequestService.getNegs().subscribe((result) => {
      this.negs = result;
    });
  }

  ngOnInit(): void { }

  changeDateFrom(value:any) { 
    this.dateConfigUpTo.min = value;
    this.dateConfigUpTo = { ...this.dateConfigUpTo };
  }

  changeDateTo(value: any){
    this.dateConfigPeriodFrom.max = value;
    this.dateConfigPeriodFrom = { ...this.dateConfigPeriodFrom };
  }

  changeDateFromForecast(value: any) {
    this.dateConfigUpToForecast.min = value;
    this.dateConfigUpToForecast = { ...this.dateConfigUpToForecast };
  }

  changeDateToForecast(value: any) {
    this.dateConfigPeriodFromForecast.max = value;
    this.dateConfigPeriodFromForecast = { ...this.dateConfigPeriodFromForecast };
  }

  // showObs(obsConcess: string) {
  //   this.dialogService.addDialog(CommentComponent, {
  //     obs: obsConcess
  //   }, this.utilService.getModalOptions()).subscribe();
  // }

  // showFinancialComment(request) {
  //   this.dialogService.addDialog(FinancialCommentComponent, {
  //     request: request
  //   }, this.utilService.getModalOptions()).subscribe((result) => {
  //     if (result && result.success) {
  //       let index = 0;
  //       index = this.credits.findIndex(c => c.id === result.financialObs.id);
  //       if (index > -1) {
  //         this.credits[index].obs = result.financialObs.obs;
  //       }

  //       this.toastr.success('Registro alterado.', 'Sucesso');
  //     }
  //   });
  // }

  exportFile() {
    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Atenção',
      message: 'Ao realizar a opção de Exportar para Arquivo novas linhas serão geradas no Follow-up. Você deseja incluí-las?'
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      let negs = this.creditFilter.negRef.length > 0 ? "'" + this.creditFilter.negRef.join("','") + "'" : "";

      let vUrl = localStorage.getItem('ffsDatabase') + this.util.getOwnerEnv() + "/pcd_consultas.ListaCreditosDealers?pCodBanco=" + this.creditFilter.bank +
        "&pExportToExcel=S" + "&pEstagioNeg=" + negs + "&pFlag=CONSULTAR" + "&pSolicitacao=" + (this.creditFilter.id || "") + "&pFrontOffice=" + this.creditFilter.frontOffice +
        "&pPeriodoDe=" + this.creditFilter.startForecast + "&pPeriodoAte=" + this.creditFilter.endForecast +
        "&pLancamentoDe=" + this.creditFilter.startRelease + "&pLancamentoAte=" + this.creditFilter.endForecast +
        "&pGerarFollowUp=" + (resultConfirm.confirmed ? 'S' : 'N');

        window.open(vUrl, '_blank');

        this.creditService.report(this.creditFilter);
    });
  }

  getAll(page: number) { 
    this.creditService.get(page, this.order, this.utilService.getOrderType(this.reverse), this.creditFilter).subscribe((result) => {
      this.credits = result.content.page;
      this.page = result.content.currentPage;
      this.total = result.content.totalRecords;
    });
  }

  resetFilters(form: NgForm) {
    this.creditFilter = new CreditFilter();
    form.resetForm(this.creditFilter);
  }

  search() { 
    this.getAll(1);
  }

  sendApproval(credit: Credit): void {
    if (!credit.approval) {
      this.toastr.error('Campo Aprovar obrigatório', 'Erro');
      return;
    }

    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Atenção',
      message: 'Deseja ' + (credit.approval == 'S' ? 'Aprovar' : 'Reprovar') + ' o crédito ' + credit.id + ' ?'
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      if (resultConfirm.confirmed) {
        let approval = new Approval(credit.id, credit.bankId, 
                                    credit.creditSitCod, credit.obs, '', 0,
                                    0, credit.endDate, credit.approval);
        
        this.creditService.sendApproval(approval).subscribe((result) => {
          if (result && !result.hasErrors) {

            let index = this.credits.findIndex(c => c.id === credit.id);
            if (index > -1) {
              this.credits.splice(index, 1);
            }

            this.toastr.success('Registro ' + (credit.approval == 'S' ? 'Aprovado' : 'Reprovado'), 'Sucesso');
          }
        });
      }
    });
  }

}
